import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ApiConnectivityService } from '../services/api-connectivity.service';
import { ApiHost } from '../services/api-connectivity.util';

@Component({
  selector: 'app-server-connectivity-indicator',
  templateUrl: './server-connectivity-indicator.component.html',
  styleUrls: ['./server-connectivity-indicator.component.scss'],
})
export class ServerConnectivityIndicatorComponent implements OnInit, OnDestroy {
  @Input() hosts: ApiHost[] = ['kiln', 'claim'];

  hasIssue = false;
  messageKey = 'CONNECTIVITY.ALL_OK';
  private subscription?: Subscription;

  constructor(
    private apiConnectivity: ApiConnectivityService,
    private toastCtrl: ToastController,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.subscription = this.apiConnectivity.getUnreachableHosts$(this.hosts).subscribe((unreachable) => {
      this.hasIssue = unreachable.length > 0;
      this.messageKey = this.hasIssue
        ? this.apiConnectivity.getIssueMessageKey(unreachable)
        : 'CONNECTIVITY.ALL_OK';
    });
  }

  async showDetails(): Promise<void> {
    const message = await this.translate.get(this.messageKey).toPromise();
    const toast = await this.toastCtrl.create({
      message,
      duration: this.hasIssue ? 6000 : 3000,
      color: this.hasIssue ? 'warning' : 'success',
    });
    await toast.present();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
